/*
 * function convert workers to dropdown options
 *
 */
export const getTextPercentPlan = (percent: number): string => {
    return !percent ? '未着手' : percent === 100 ? '完了' : percent + '%';
};
